import { CHART_DOT_BORDER, CHART_DOT_HEIGHT, CHART_DOT_WIDTH } from '../../config';

export type DashboardChartDotProps = {
	cx?: number;
	cy?: number;
	stroke?: string;
};

export const DashboardChartDot = ({ cx, cy, stroke }: DashboardChartDotProps) => {
	if (typeof cx !== 'number' || typeof cy !== 'number') return null;

	return (
		<ellipse
			cx={cx}
			cy={cy}
			rx={(CHART_DOT_WIDTH - CHART_DOT_BORDER) / 2}
			ry={(CHART_DOT_HEIGHT - CHART_DOT_BORDER) / 2}
			fill='var(--color-slate-50)'
			stroke={stroke}
			strokeWidth={CHART_DOT_BORDER}
		/>
	);
};
